// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ICreateDocumentDto
 */
export interface ICreateDocumentDto {
    /**
     * 
     * @type {number}
     * @memberof ICreateDocumentDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICreateDocumentDto
     */
    document_type: ICreateDocumentDtoDocumentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICreateDocumentDto
     */
    organization_path: string;
    /**
     * 
     * @type {number}
     * @memberof ICreateDocumentDto
     */
    organization_id: number;
}

/**
* @export
* @enum {string}
*/
export enum ICreateDocumentDtoDocumentTypeEnum {
    RECEIPT = 'RECEIPT',
    STATEMENT = 'STATEMENT',
    LOCKBOX = 'LOCKBOX',
    LETTER_OF_MEDICAL_NECESSITY = 'LETTER_OF_MEDICAL_NECESSITY'
}


/**
 * Check if a given object implements the ICreateDocumentDto interface.
 */
export function instanceOfICreateDocumentDto(value: object): value is ICreateDocumentDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('document_type' in value) || value['document_type'] === undefined) return false;
    if (!('organization_path' in value) || value['organization_path'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function ICreateDocumentDtoFromJSON(json: any): ICreateDocumentDto {
    return ICreateDocumentDtoFromJSONTyped(json, false);
}

export function ICreateDocumentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICreateDocumentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'document_type': json['document_type'],
        'organization_path': json['organization_path'],
        'organization_id': json['organization_id'],
    };
}

export function ICreateDocumentDtoToJSON(json: any): ICreateDocumentDto {
    return ICreateDocumentDtoToJSONTyped(json, false);
}

export function ICreateDocumentDtoToJSONTyped(value?: ICreateDocumentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'document_type': value['document_type'],
        'organization_path': value['organization_path'],
        'organization_id': value['organization_id'],
    };
}

